export enum ReceiptViewState {
  ToApprove,
  MissingInfo,
  MissingPaymentInfo,
  Other,
}

export enum ReceiptViewStatus {
  ForFinalApproval,
  InProcess,
  InTheBooks,
  Cancelled,
  Draft,
  SupplementRequested,
}
